import { CLUSTERS } from '../clusters.js';
import { APPSDEVELOPER_CLUSTER } from '../mapped-clusters/appsdeveloper.js';
import { CONSTRUCTION_CLUSTER } from '../mapped-clusters/construction.js';
import { CRM_CLUSTER } from '../mapped-clusters/crm.js';
import { DESIGN_AND_CREATIVE_CLUSTER } from '../mapped-clusters/design_and_creative.js';
import { EDUCATION_CLUSTER } from '../mapped-clusters/education.js';
import { FINANCE_CLUSTER } from '../mapped-clusters/finance.js';
import { FUNDRAISING_CLUSTER } from '../mapped-clusters/fundraising.js';
import { HR_CLUSTER } from '../mapped-clusters/hr.js';
import { INFORMATION_TECHNOLOGY_CLUSTER } from '../mapped-clusters/information_technology.js';
import { LEGAL_CLUSTER } from '../mapped-clusters/legal.js';
import { MARKETING_CLUSTER } from '../mapped-clusters/marketing.js';
import { NGO_CLUSTER } from '../mapped-clusters/ngo.js';
import { OPERATIONS_CLUSTER } from '../mapped-clusters/operations.js';
import { OTHER_CLUSTER } from '../mapped-clusters/other.js';
import { PMO_CLUSTER } from '../mapped-clusters/pmo.js';
import { PRODUCT_MANAGEMENT_CLUSTER } from '../mapped-clusters/product_management.js';
import { TECH_CLUSTER } from '../mapped-clusters/tech.js';
import { PROJECTS_FLOW_CLUSTER } from '../mapped-clusters/projects_flow.js';
import { SPACES_CLUSTER } from '../mapped-clusters/spaces.js';
import { WORK_MANAGEMENT_CLUSTER } from '../mapped-clusters/work_management.js';

const HOMEPAGE_CLUSTERS_DATA = {
    [CLUSTERS.HR]: HR_CLUSTER,
    [CLUSTERS.CONSTRUCTION]: CONSTRUCTION_CLUSTER,
    [CLUSTERS.DESIGN_AND_CREATIVE]: DESIGN_AND_CREATIVE_CLUSTER,
    [CLUSTERS.INFORMATION_TECHNOLOGY]: INFORMATION_TECHNOLOGY_CLUSTER,
    [CLUSTERS.NGO]: NGO_CLUSTER,
    [CLUSTERS.EDUCATION]: EDUCATION_CLUSTER,
    [CLUSTERS.PMO]: PMO_CLUSTER,
    [CLUSTERS.FINANCE]: FINANCE_CLUSTER,
    [CLUSTERS.MARKETING]: MARKETING_CLUSTER,
    [CLUSTERS.TECH]: TECH_CLUSTER,
    [CLUSTERS.OPERATIONS]: OPERATIONS_CLUSTER,
    [CLUSTERS.LEGAL]: LEGAL_CLUSTER,
    [CLUSTERS.PRODUCT_MANAGEMENT]: PRODUCT_MANAGEMENT_CLUSTER,
    [CLUSTERS.CRM]: CRM_CLUSTER,
    [CLUSTERS.PROJECTS_FLOW]: PROJECTS_FLOW_CLUSTER,
    [CLUSTERS.FUNDRAISING]: FUNDRAISING_CLUSTER,
    [CLUSTERS.SPACES]: SPACES_CLUSTER,
    [CLUSTERS.APPSDEVELOPER]: APPSDEVELOPER_CLUSTER,
    [CLUSTERS.WORK_MANAGEMENT]: WORK_MANAGEMENT_CLUSTER,
    [CLUSTERS.OTHER]: OTHER_CLUSTER,
};

export { HOMEPAGE_CLUSTERS_DATA };
